import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AddNewFileTypeForm from "../../components/pageManager/AddNewFileTypeForm";

const AddNewFileTypeFormPage = ({geoIds}) => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AddNewFileTypeForm geoIds={geoIds}/>
                </div>
            </div>
        </div>
    );
};

export default AddNewFileTypeFormPage;
